import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, TemplateRef } from '@angular/core';
import { LoadingSpinnerComponent } from '../../../../../aptem-component-library/components/loading-spinner/loading-spinner.component';
import { LoadingSpinnerConfig } from '../../../../../aptem-component-library/components/loading-spinner/loading-spinner.models';
import { PageConfig } from './form.models';

@Component({
    selector: 'app-form-page',
    imports: [CommonModule, LoadingSpinnerComponent],
    templateUrl: './form.component.html',
    styleUrl: './form.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormPageComponent {
  @Input() public config: PageConfig | null = null;
  @Input({ required: true }) public content: TemplateRef<any> | null = null;
  @Input() public input: TemplateRef<any> | null = null;
  @Input() public action: TemplateRef<any> | null = null;

  protected loadingSpinnerConfig: LoadingSpinnerConfig = {
    size: 'lg',
  };
}
